import { create } from "zustand";
import { devtools } from "zustand/middleware";
import {
  allowedeventLookup,
  deleteHubs,
  deleteServiceareas,
  editHubs,
  editHubsbypatch,
  editServiceAreas,
  exportHubs,
  exportServiceAreas,
  filterHubs,
  getAllAreasbyHub,
  getHub,
  getHubTemplate,
  getHubTypes,
  getHubs,
  getHubsbyId,
  getServiceAreas,
  getServiceAreasTemplate,
  importHub,
  importServiceAreas,
  postHubs,
  postServiceAreas,
} from "../../services/Hubs/Hub_services";

const initialValues = {
  zoneServiceData: [],
  hubsData: [],
  hubTypes: [],
  allowedeventData: [],
};

let hubStore = (set) => ({
  ...initialValues,
  getHubs: async (params) => {
    const response = await getHubs(params);
    set({ hubsData: response });
    return response;
  },
  getHub: async (params) => {
    const response = await getHub(params);
    set({ hubsfilterData: response });
    return response;
  },
  filterHubs: async (params) => {
    const response = await filterHubs(params);
    set({ hubsData: response });
    return response;
  },
  getHubsbyId: async (params) => {
    const response = await getHubsbyId(params);
    return response;
  },
  editHubs: async (params) => {
    const response = await editHubs(params);
    return response;
  },
  editHubsbypatch: async (params, data) => {
    const response = await editHubsbypatch(params, data);
    return response;
  },
  postHubs: async (params) => {
    const response = await postHubs(params);
    return response;
  },
  getHubTypes: async () => {
    const response = await getHubTypes();
    set({ hubTypes: response });
    return response;
  },
  deleteHubs: async (params) => {
    const response = await deleteHubs(params);
    return response;
  },
  exportHubs: async (params) => {
    const response = await exportHubs(params);
    return response;
  },
  importHub: async (params) => {
    const response = await importHub(params);
    return response;
  },
  getHubTemplate: async () => {
    const response = await getHubTemplate();
    return response;
  },
  getServiceAreas: async (params) => {
    const response = await getServiceAreas(params);
    return response;
  },
  getAllAreasbyHub: async (params) => {
    const response = await getAllAreasbyHub(params);
    set({ zoneServiceData: response });
    return response;
  },
  postServiceAreas: async (params) => {
    const response = await postServiceAreas(params);
    return response;
  },
  editServiceAreas: async (params) => {
    const response = await editServiceAreas(params);
    return response;
  },
  deleteServiceareas: async (params) => {
    const response = await deleteServiceareas(params);
    return response;
  },
  getServiceAreasTemplate: async () => {
    const response = await getServiceAreasTemplate();
    return response;
  },
  exportServiceAreas: async (params) => {
    const response = await exportServiceAreas(params);
    return response;
  },
  importServiceAreas: async (params, data) => {
    const response = await importServiceAreas(params, data);
    return response;
  },
  allowedeventLookup: async () => {
    const response = await allowedeventLookup();
    set({ allowedeventData: response });
    return response;
  },
});

hubStore = devtools(hubStore);

export const useHubStore = create(hubStore);
